import * as React from "react";
import type { SVGProps } from "react";
export const SvgMiscDoubleArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M8 3.224 3.862 7.362l.943.942L8 5.11l3.195 3.195.943-.942L8 3.224ZM8 6.99l-4.138 4.138.943.943L8 8.876l3.195 3.195.943-.943L8 6.99Z"
    />
  </svg>
);
